
import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import loginRouter from './loginRouter'
import homeRouter from './homeRouter'
import visualDataRouter from './visualDataRouter'

Vue.use(Router)

const router = new Router({
  routes: [
    loginRouter,
    homeRouter,
    visualDataRouter
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path !== '/' && !localStorage.getItem('token')) {
    next('/')
  }
  // 生成面包屑数据
  const toPath = to.path.substring(to.path.lastIndexOf('/') + 1)
  const breadCrumbList = []
  const routerList = homeRouter.children
  routerList.forEach(firstItem => {
    const { children } = firstItem
    if (children.length > 0) {
      children.forEach(secondItem => {
        const { path } = secondItem
        if (path === toPath) {
          breadCrumbList.push(firstItem.name, secondItem.name)
        }
      })
    }
  })
  store.commit('updateBreadCrumbList', breadCrumbList)
  // 设置页面title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (process.env.EVN_CONFIG === 'dev') {
    localStorage.setItem('apiRoot', 'http://47.92.242.235:4604')
  } else {
    // 获取协议类型
    const urlProtocol = window.location.protocol
    // 获取域名地址
    const urlHost = window.location.host
    // 缓存请求地址
    localStorage.setItem('apiRoot', `${urlProtocol}//${urlHost}`)
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js